<template>
    <svg width="100%" height="100%">
        <line :x1="point1.x" :y1="point1.y" :x2="point2.x" :y2="point2.y" stroke="white" stroke-width="2"></line>
    </svg>
</template>
<script>
    export default {
        name: 'DynamicLine',
        props: {
            point1: {
                type: Object,
                required: true
            },
            point2: {
                type: Object,
                required: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/console/components/DynamicLine.vue